import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({
  size = 'medium',
  text = 'Loading...',
  message = '', // Alias for text
  color = 'success', // Default to brand green
  fullScreen = false,
  overlay = false,
  className = ''
}) => {
  const displayText = message || text;
  const sizeClasses = {
    small: 'loading-small',
    medium: 'loading-medium',
    large: 'loading-large',
    xlarge: 'loading-xlarge'
  };

  const colorClasses = {
    primary: 'loading-primary',
    secondary: 'loading-secondary',
    success: 'loading-success',
    warning: 'loading-warning',
    danger: 'loading-danger',
    light: 'loading-light',
    dark: 'loading-dark'
  };

  const content = (
    <div className={`loading-container ${className}`}>
      <div className={`brand-loader ${sizeClasses[size]} ${colorClasses[color]}`}>
        <div className="loader-inner"></div>
      </div>
      {displayText && (
        <div className={`loading-text ${colorClasses[color]}`}>
          {displayText}
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        {content}
      </div>
    );
  }

  if (overlay) {
    return (
      <div className="loading-overlay">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;
